import { configStore } from "./state/CommonState"
import Quote from './Quote'
import QuoteView from './QuoteView'
import { useSnapshot } from "valtio"
import ListQuote from "./ListQuote"
import QuoteViewMain from "./QuoteViewMain"
import QuoteListClient from "./schedules/QuoteListClient"

export default function QuoteMain() {
    const a = useSnapshot(configStore)
    /*if (configStore.quoteListMode) return <ListQuote/>
    if (configStore.quoteEditMode)
    return <Quote/>
    else return <QuoteView/>*/
    switch(a.quoteCurrentView) {
        case 'list': return <ListQuote/>
        case 'view': return <QuoteViewMain/>
        case 'pureView': return <QuoteView />
        case 'edit': return <Quote />
    }
}